import React from "react";
import PropTypes from "prop-types";
import styles from "./Feature.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import * as Icons from "@fortawesome/free-solid-svg-icons";

const iconList = Object.keys(Icons)
  .filter((key) => key !== "fas" && key !== "prefix")
  .map((icon) => Icons[icon]);

library.add(...iconList);

export default function Feature({ icon, header, description, flip }) {
  
  return (
    <>
      <div className={styles.container}>
        <span className={styles.circle}>
          <FontAwesomeIcon className={styles.faIcon} icon={icon} flip={flip} />
        </span>
        <strong className={styles.header}>{header}</strong>
        <p className={styles.description}>{description}</p>
      </div>
    </>
  );
}
Feature.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  header: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  flip: PropTypes.oneOf(["horizontal", "vertical"]),
};
